import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { billingYearLabel } from './ClientBillingSummary';
import { formatLedgerAmount } from './clientLedgerTypes';

export default function ClientYearTransferForm({ sourceYear, availableCents, summary, onSubmit, onCancel, busy, reversal }) {
  const { t, i18n } = useTranslation();
  const [amount, setAmount] = useState(String(availableCents / 100));
  const [reason, setReason] = useState('');
  const cents = /^\d+(\.\d{1,2})?$/.test(amount) ? Math.round(Number(amount) * 100) : NaN;
  const valid = reversal ? !!reason.trim() : Number.isSafeInteger(cents) && cents > 0 && cents <= availableCents;
  const enteredCents = Number.isFinite(cents) ? cents : 0;
  const value = reversal ? availableCents : enteredCents;
  const balance = year => (summary.years.find(item => item.schoolYearStartYear === year) || {}).balanceCents || 0;
  const money = valueInCents => formatLedgerAmount(valueInCents / 100, i18n.language);
  return (
    <form className="card p-3 mb-3" onSubmit={event => { event.preventDefault(); if (valid && !busy) onSubmit({ amount, reason }); }}>
      <h3>{t(`billing:yearScope.${reversal ? 'reverse' : 'transfer'}`)}</h3>
      <div>{billingYearLabel(sourceYear)} → {billingYearLabel(sourceYear + 1)}</div>
      {reversal ? <label htmlFor="transfer-reason">{t('billing:yearScope.reason')}<input id="transfer-reason" className="form-control" required maxLength={1000} value={reason} onChange={event => setReason(event.target.value)} /></label>
        : <label htmlFor="transfer-amount">{t('manage:amount_131')}<input id="transfer-amount" className="form-control" inputMode="decimal" required value={amount} onChange={event => setAmount(event.target.value)} /></label>}
      <p>{t('billing:yearScope.after')}: {billingYearLabel(sourceYear)}: {money(balance(sourceYear) + (reversal ? value : -value))};
        {' '}{billingYearLabel(sourceYear + 1)}: {money(balance(sourceYear + 1) + (reversal ? -value : value))}
      </p>
      <div><button disabled={!valid || busy} type="submit" className="btn manage-button manage-red-button mr-2">{t(`billing:yearScope.${reversal ? 'confirmReverse' : 'confirmTransfer'}`)}</button>
        <button disabled={busy} type="button" className="btn manage-button manage-teal-button" onClick={onCancel}>{t('common:cancel')}</button>
      </div>
    </form>
  );
}
ClientYearTransferForm.propTypes = { sourceYear: PropTypes.number.isRequired,
  availableCents: PropTypes.number.isRequired,
  summary: PropTypes.object.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  reversal: PropTypes.bool };
ClientYearTransferForm.defaultProps = { busy: false, reversal: false };
